import { useEffect, useState } from 'react';
import type { MenuProps } from 'antd';
import { Col, Layout, Menu, Row } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { itemsMain, itemsMainV2 } from '../MainLayout/items';
import { ReactComponent as PositivehotelLogo } from '../../assets/images/positivehotelLogo.svg'
import PageHistory from '../../components/PageHistory';
import Notification from '../../utils/firebaseNotifications/Notification';
import { getLocalAccessToken, removeUser, validateToken } from '../../service/Token';

const MinimalLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState<string>(location.pathname);
    const token = getLocalAccessToken();
    const onClick: MenuProps['onClick'] = (clicked) => {
        setSelectedKey(clicked.key)
        navigate(clicked.key)
    };

    useEffect(() => {
        if (!token) return;
        validateToken()
            .catch(() => { removeUser(); return navigate("/login"); })
    }, [token])

    return <>
        <Layout>
            <Layout.Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} theme='light'>
                <Row style={{ margin: "16px", textAlign: "center" }}>
                    <Col span={24} style={{ fontSize: 18 }}><PositivehotelLogo width={162} height={16} /></Col>
                </Row>
                <Menu selectedKeys={[selectedKey]} mode="inline" items={itemsMainV2} onClick={onClick} />
            </Layout.Sider>
            <Layout>
                <Layout.Header style={{ padding: 0, display: "flex", justifyContent: "end", alignItems: "center", paddingInline: "6%", gap: "24px", backgroundColor: 'white' }}>
                    <Notification />
                </Layout.Header>
                <Layout.Content style={{ margin: '0 16px' }}>
                    <PageHistory />
                    <div style={{ backgroundColor: 'white', padding: '20px' }}>
                        <Outlet />
                    </div>
                </Layout.Content>
                <Layout.Footer style={{ textAlign: 'center' }}></Layout.Footer>
            </Layout>
        </Layout>
    </>
};

export default MinimalLayout;